import { Box, Image, Text, useDisclosure } from "@chakra-ui/react";
import { AiOutlineUpload } from "react-icons/ai";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import MediaLibraryModal from "./MediaLibraryModal";

export default function ImageUpload({ onSetImage, imageUrl }) {
    const { t } = useTranslation('common');
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [selectedImage, setSelectedImage] = useState(imageUrl);

    const handleSelectImage = (url) => {
        setSelectedImage(url);
        onSetImage(url);
    };

    if (selectedImage) {
        return (
            <>
                <Box boxSize='200px'
                    onClick={onOpen}
                    background={'var(--chakra-colors-gray-100)'} border={'1px solid #000000'}
                    borderRadius={"12px"} cursor={"pointer"}
                    position="relative"
                    overflow="hidden"
                >
                    <Image objectFit='cover' height="100%" width={'100%'} src={selectedImage} fallbackSrc='https://via.placeholder.com/150' />

                    <Box
                        position="absolute"
                        bottom={0}
                        left={0}
                        right={0}
                        bg="rgba(0,0,0,0.6)"
                        p={1}
                        display="flex"
                        justifyContent="center"
                    >
                        <Text fontSize="xs" color="white">{t('change', 'Change')}</Text>
                    </Box>
                </Box>
                <MediaLibraryModal isOpen={isOpen} onClose={onClose} onSelectImage={handleSelectImage} />
            </>
        )
    }

    return (
        <>
            <Box w={"100%"}
                justifyContent={'center'}
                alignItems={'center'}
                display={'flex'}
                flexDirection="column"
                boxSize='200px' background={'var(--chakra-colors-gray-100)'} border={'1px solid #000000'}
                borderRadius={"12px"} cursor={"pointer"}
                onClick={onOpen}
                gap={2}
            >
                <AiOutlineUpload size={24} />
                <Text>{t('uploadPhoto')}</Text>
            </Box>
            <MediaLibraryModal isOpen={isOpen} onClose={onClose} onSelectImage={handleSelectImage} />
        </>
    )
}
